export default __webpack_public_path__ + "static/media/dag.716aaaa8.webp";